module.exports = __webpack_public_path__ + "static/media/audi_zertifikat_2010_1.457bd79d.jpg";